import consts from "@/consts.js";
import Request from './request';
import store from "../store";
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';

async function fetch(data) {
    return Request('get', "api/suppliers", data);
}
async function fetchOne(id) {// 获取单个
    return Request('get', "api/suppliers/" + id);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/suppliers", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    data.fieldFilter = ["id", "supplier_code", "supplier_name"]; //仅筛选少许必要字段
    return Request('get', "api/suppliers/select", data, false, false, true);
}

async function del(id) {
    return Request('delete', 'api/suppliers/delete/' + id)
}

// 新增 编辑 保存
async function save(id, data) {
    if (id) {
        return Request('post', 'api/suppliers/edit?id=' + id, data);
    } else {
        return Request('post', 'api/suppliers/add', data)
    }
}

async function syncChanjetMaterials(id) {
    return Request('get', 'api/chanjet/sync-materials', {
        supplier_id: id
    })
}

async function syncChanjetShops(id) {
    return Request('get', 'api/chanjet/sync-shops', {
        supplier_id: id
    })
}

async function templateExport() {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/suppliers/template-export/')
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function Import(file) {// 导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/suppliers/import",data)
}

async function exports(data) {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/suppliers/supplier-export', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function checkPurchaseAfterSetPriceClose(id) {
    return Request('get', "api/suppliers/checkPurchaseAfterSetPriceClose/" + id);
}

async function syncThirdSupplier() {
    return Request('get', "api/suppliers/sync-third-supplier/");
}

async function getCriteriaSetting() {
    return Request('get', "api/suppliers/criteria-setting");
}

async function saveCriteriaSetting(data) {
    return Request('post', "api/suppliers/criteria-setting-save", data);
}

async function scoreBatchSave(data) {
    return Request('post', "api/suppliers/score-batch-save", data);
}

async function getSupplierScore(data) {
    return Request('get', 'api/suppliers/supplier-score', data)
}

async function supplierScoreExport(data) {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/suppliers/supplier-score-export', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function getSupplierScoreView(data) {
    return Request('get', 'api/suppliers/supplier-score-view', data)
}

async function supplierScoreViewExport(data) {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/suppliers/supplier-score-view-export', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function getSupplierScoreLogs(data) {
    return Request('get', 'api/suppliers/score-logs', data)
}

async function syncYongYouData(data) {
    return Request('post', 'api/suppliers/syncYongYouData', data)
}

async function supplierComplaintImport(file) {// 导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/suppliers/supplier-complaint-import", data);
}

async function fetchAllNoPaging(data) {
    if (!data) data = {};
    // data.limit = consts.limitAll; //获取全部
    return Request('post', "api/suppliers/select", Object.assign({},data,{
        itemsPerPage: consts.limitAll,
        limit: consts.limitAll,
    }));
}

async function selfPurchaseSave(data) {
    return Request('post', 'api/suppliers/selfPurchaseSave', data)
}

export default {
    fetch,
    fetchOne,
    fetchAll,
    fetchAllForSelect,
    del,
    save,
    syncChanjetMaterials,
    syncChanjetShops,
    templateExport,
    Import,
    exports,
    checkPurchaseAfterSetPriceClose,
    syncThirdSupplier,
    getCriteriaSetting,
    saveCriteriaSetting,
    scoreBatchSave,
    getSupplierScore,
    supplierScoreExport,
    getSupplierScoreView,
    supplierScoreViewExport,
    getSupplierScoreLogs,
    syncYongYouData,
    supplierComplaintImport,
    fetchAllNoPaging,
    selfPurchaseSave,
};